import { render, staticRenderFns } from "./FlatButton.vue?vue&type=template&id=5766a39a&scoped=true&lang=pug&"
import script from "./FlatButton.vue?vue&type=script&lang=ts&"
export * from "./FlatButton.vue?vue&type=script&lang=ts&"
import style0 from "./FlatButton.vue?vue&type=style&index=0&id=5766a39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766a39a",
  null
  
)

export default component.exports